import { render, staticRenderFns } from "./emailPreviewDialog.vue?vue&type=template&id=8781218c&scoped=true&"
import script from "./emailPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./emailPreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8781218c",
  null
  
)

export default component.exports